module.exports = "<div *ngIf=\"LOAD === true\" [class]=\"IMAGE\"></div>"


//////////////////
// WEBPACK FOOTER
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/components/loader/loading.component.html
// module id = IWwt
// module chunks = 7